import React from 'react'
import { useParams } from 'react-router'
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import PageCalling from 'src/components/common/PageCalling'
import Timer from 'src/components/views/mkt03/Timer'
import useAPI from 'src/hooks/useAPI'
import { useCheckTelecomIsBlock } from 'src/hooks/useCheckTelecomIsBlock'
import { useTelList } from 'src/hooks/useTelList'
import useValid from 'src/hooks/useValid'
import {
  CertNumState,
  RecoilStateList,
  TelTypeState,
  uiData
} from 'src/recoil/common'
import * as S from 'src/styles/styledcomponent/views/mkt03/PhoneVerification'
import { PramsKeys } from 'src/types/type'
import { useAutoInputGuard } from "src/hooks/useAutoInputGuard";

const PhoneVerification = (props: any): JSX.Element => {
  const { onMoveToElement, RefInput, submit, openToast } = props
  const { pcode } = useParams<PramsKeys>()
  const telList = useTelList()
  const handleValid = useValid()
  const CertApi = useAPI('requestSendCertNumber')
  const JoinApi = useAPI('requestJoin')

  useCheckTelecomIsBlock()

  const { TelType, PhoneNum, CertNum, CertCheck, Timeout, termsAgree, authKeyValue, TransId, TermsData } =
    useRecoilValue(RecoilStateList)
  const setTelType = useSetRecoilState(TelTypeState)
  const ResetCertNum = useResetRecoilState(CertNumState)
  const {
    layoutsConfirm: { submitBtn },
    layoutsInsert: {
      certs: { backgroundColor: certsBgColor, borderColor: certsBorderColor },
      agency: { actColor },
    },
  } = useRecoilValue(uiData)

  const { mutateAsync: getSendOtp, isLoading: certLoading } = CertApi.useSetMutation({
    Telecom: TelType,
    PNumber: PhoneNum,
    Pcode: pcode,
  })
  const { mutateAsync: JoinRequest, isLoading: joinLoading } = JoinApi.useSetMutation({
    Telecom: TelType,
    PNumber: PhoneNum,
    TranID: TransId,
    ApprovalNumber: Number(CertNum),
    TermsIdx: TermsData.TermsIdx,
    PCode: pcode,
    TermsAgree: termsAgree.join(""),
    authKey: authKeyValue,
  })

  const requestCert = () => {
    submit.validationCert(getSendOtp)
    ResetCertNum()
    setTimeout(() => {
      document.getElementById('certInput')?.focus()
    }, 1000)
  }
  const handleJoinOnKeyUp = useAutoInputGuard(() => submit.join(JoinRequest))

  const CertOnKeyUpFunc = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') requestCert()
  }
  const TelecomSelector = async (option: number) => {
    setTelType(option)
    openToast()
    onMoveToElement()
  }

  return (
    <S.PhoneVerificationWrap
      backgroundColor={certsBgColor}
      borderColor={actColor}
      ref={props.RefElement}
    >
      <PageCalling active={certLoading || joinLoading} />
      <S.TelSelectorWrap>
        {telList?.map((element) => (
          <S.TelCircleWrap bgActive={TelType === element.idx} actColor={actColor} key={element.idx}>
            <S.Telecoms
              className={element.text}
              bgActive={TelType === element.idx}
              oneTelStyle={telList?.length === 1}
              actColor={actColor}
              disabled={CertCheck}
              onClick={() => TelecomSelector(element.idx)}
            />
          </S.TelCircleWrap>
        ))}
      </S.TelSelectorWrap>
      <S.TelPhoneNumWrap>
        <S.TelInput
          className="ipt_phonenumber"
          borderColor={certsBorderColor}
          backgroundColor={!CertCheck ? '#fff' : '#FAFAFA'}
          fontColor={!CertCheck ? '#000' : '#999'}
          type="tel"
          ref={RefInput}
          placeholder="휴대폰번호를 입력하세요."
          maxLength={11}
          value={PhoneNum}
          onChange={handleValid.phoneNumValid}
          onKeyUp={CertOnKeyUpFunc}
          disabled={CertCheck}
          onClick={onMoveToElement}
        />
        {!CertCheck ? (
          <S.CertSubmitBtn
            className="btn_send_sms"
            {...submitBtn}
            backgroundColor={submitBtn.backgroundColor}
            onClick={requestCert}
            disabled={PhoneNum.length !== 11}
          >
            인증번호 발송
          </S.CertSubmitBtn>
        ) : (
          <section>
          <S.CertInputContainer>
            <S.CertInput
              id={'certInput'}
              className="ipt_smscode"
              type="tel"
              placeholder="인증번호 입력"
              maxLength={4}
              value={CertNum}
              onChange={handleValid.certNumValid}
              onKeyUp={handleJoinOnKeyUp}
            />
            <Timer time={Timeout} />
            <S.ReCertBtn onClick={requestCert}>재전송</S.ReCertBtn>
            </S.CertInputContainer>
          </section>
        )}
      </S.TelPhoneNumWrap>
    </S.PhoneVerificationWrap>
  )
}

export default PhoneVerification
